// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.floorplans.RentalManagerUserPropertyFloorPlanLayoutV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyFloorPlanLayoutV2WebApiHandler_delete } from '@zg-rentals/ts-rental-manager-api-client';

import type { UserPropertyFloorPlanLayoutDeleteV2RequestDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyFloorPlanLayoutV2WebApiHandler_delete_Args {
  postData: UserPropertyFloorPlanLayoutDeleteV2RequestDto;
}

export type RentalManagerUserPropertyFloorPlanLayoutV2WebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyFloorPlanLayoutV2WebApiHandler_delete_Args
>;

/**
 * Delete a property layout
 */
export const useRentalManagerUserPropertyFloorPlanLayoutV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanLayoutV2WebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanLayoutV2WebApiHandler_delete_Args) =>
      RentalManagerUserPropertyFloorPlanLayoutV2WebApiHandler_delete(args.postData, httpClient),
  });
};
